/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Freelabel1Inputs */

const zh_plan_freelabel1 = /** @type {(inputs: Plan_Freelabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费版`)
};

const en_plan_freelabel1 = /** @type {(inputs: Plan_Freelabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const es_plan_freelabel1 = /** @type {(inputs: Plan_Freelabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Plan_Freelabel1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_freelabel1 = /** @type {((inputs?: Plan_Freelabel1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Freelabel1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_freelabel1(inputs)
	if (locale === "en") return en_plan_freelabel1(inputs)
	return es_plan_freelabel1(inputs)
});
export { plan_freelabel1 as "plan_freeLabel" }